import * as React from "react";
import * as moment from "moment";
import UserInfo from "../../model/UserInfo";
import IdentityText from "../IdentityText";
import ImpersonateAction from "../../model/ImpersonateAction";
import { fillTemplateString } from "../../utils/text-rendering";
import "./UserCardMedium.scss";
import Avatar, { AvatarSize } from "./Avatar";
import TextAction from "../action/TextAction";
import { dateWithOptionalTime } from "../../utils/date";

interface UserCardMediumProps {
  user: UserInfo;
  impersonateAction?: ImpersonateAction;
  pageUrl?: string;
  patientPortalAccountCreationUrl?: string;
}

const formatBirthDateAndAge = (birthDate: string) => {
  const age = fillTemplateString(i18n["Global.Age"], {
    age: moment().diff(moment(birthDate), "years").toString(),
  });
  return `${dateWithOptionalTime(birthDate)} (${age})`;
};

const UserCardMedium = (props: UserCardMediumProps) => {
  const user = props.user;
  return (
    <div className="user-card-medium">
      <Avatar userInfo={user} size={AvatarSize.MEDIUM} />
      <div>
        <IdentityText
          identity={{
            email: user.email,
            fullName: user.name,
            displayName: user.name,
            canBeImpersonated: !!props.impersonateAction,
          }}
          impersonateAction={props.impersonateAction}
        />
        {user.practiceName && <div id="practice-name">{user.practiceName}</div>}
        {user.birthDate && <div id="birthdate">{formatBirthDateAndAge(user.birthDate)}</div>}
        {props.pageUrl && (
          <div>
            <TextAction
              id="view-patient-file"
              label={i18n["User.Card.ViewPatientFile.Link"]}
              href={props.pageUrl}
            />
          </div>
        )}
        {props.patientPortalAccountCreationUrl && (
          <div
            id="patient-portal"
            className="text-action"
            onClick={() => window.open(props.patientPortalAccountCreationUrl, "_self")}
          >
            {i18n["Form.GenericRegistration.Submit"]}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserCardMedium;
